(() => {
  const updateCartCount = async (event) => {
    const cartLink = document.querySelector('[data-r222-cart-url]');
    if (!cartLink) return;
    try {
      let cart = event.detail?.cart;
      if (!cart || typeof cart.item_count !== 'number') {
        const response = await fetch(cartLink.dataset.r222CartUrl + '.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        cart = await response.json();
      }
      document.querySelectorAll('.cart-total').forEach(total => { total.textContent = cart.item_count; });
      document.querySelectorAll('[data-r222-cart-count]').forEach(count => {
        count.textContent = cart.item_count;
        count.hidden = cart.item_count === 0;
      });
    } catch (_) { /* The cart page remains available if the badge cannot refresh. */ }
  };
  document.addEventListener('ajaxProduct:added', updateCartCount);
  document.addEventListener('cart:update', updateCartCount);
  const init = (root = document) => {
    root.querySelectorAll('[data-van-mode]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const visual = button.closest('.r222-visual');
        visual.querySelector('[data-van]').dataset.mode = button.dataset.vanMode;
        visual.querySelectorAll('[data-van-mode]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
    const params = new URLSearchParams(location.search);
    const allowed = ['vehicle-project','lettering','replacement','fleet','public-safety','custom-build','custom-wrap','specialty','other'];
    const service = params.get('service') === 'pilot' ? 'vehicle-project' : params.get('service');
    root.querySelectorAll('[data-r222-service]').forEach(select => {
      if (allowed.includes(service)) select.value = service;
    });
    const campaign = ['utm_source','utm_medium','utm_campaign'].map(key => {
      const value = params.get(key);
      return value ? key + ': ' + value.slice(0,120) : '';
    }).filter(Boolean).join(' | ');
    root.querySelectorAll('[data-r222-campaign]').forEach(input => { input.value = campaign || 'Direct / site navigation'; });
    if (campaign) root.querySelectorAll('a[href^="/pages/contact"]').forEach(link => {
      const url = new URL(link.getAttribute('href'),location.origin);
      ['utm_source','utm_medium','utm_campaign'].forEach(key => { if(params.get(key)) url.searchParams.set(key,params.get(key).slice(0,120)); });
      link.setAttribute('href',url.pathname+url.search);
    });
    root.querySelectorAll('.r222-mobile-menu a').forEach(link => link.addEventListener('click', () => { link.closest('details').open = false; }));
    const sticky = document.querySelector('.r222-mobile-cta');
    const quote = document.getElementById('request-quote');
    if (sticky && quote && !sticky.dataset.observing && 'IntersectionObserver' in window) {
      sticky.dataset.observing = 'true';
      const observer = new IntersectionObserver(entries => { sticky.classList.toggle('is-hidden',entries[0].isIntersecting); },{threshold:0});
      observer.observe(quote);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();


